import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import getVideoId from 'get-video-id';
import SbEditable from 'storyblok-react';

import ColorPicker from '../../helpers/ColorPicker';

const Youtube_Size = ({ content }) => {
  if (!content.YoutubeURL) return null;

  const { id } = getVideoId(content.YoutubeURL);
  const theme = ColorPicker(content.BgColor, false);

  return (
    <SbEditable content={content}>
      <VideoWrap themeBackground={theme.background}>
        <Youtubeframe
          width={content.width || "100%"}
          height={content.height || "auto"}
          src={`https://www.youtube.com/embed/${id}?autoplay=1&mute=1`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </VideoWrap>
    </SbEditable>
  );
};

export default Youtube_Size;

// Styled components
const Youtubeframe = styled.iframe`
  position: relative;
  aspect-ratio: 16 / 9;
  max-width: 920px;
  width: 100%;
  margin: 0px auto;
  display: block;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }

  @media only screen and (max-width: 240px) {
    width: 100%;
  }
`;

const VideoWrap = styled.section`
  padding: 4rem;
  margin: auto;
  background-color: var(--${(props) => props.themeBackground});

  @media (min-width: 640px) {
    padding: 2rem;
  }
  @media only screen and (max-width: 768px), only screen and (max-device-width: 768px) {
    padding: 2rem;
  }
  @media only screen and (max-width: 240px), only screen and (max-device-width: 240px) {
    padding: 2rem;
  }
`;

Youtube_Size.propTypes = {
  content: PropTypes.shape({
    BgColor: PropTypes.string,
    YoutubeURL: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
  }),
};

Youtube_Size.defaultProps = {
  content: {
    BgColor: 'grey--0',
    YoutubeURL: null,
    width: null,
    height: null,
  },
};